import type { QueryClient } from '@tanstack/react-query';

/** Refresh board preview, assignment, and sync UI after a direct play. */
export function invalidateAfterPlayContent(
  queryClient: QueryClient,
  organisationId: string,
  screenId: string,
): void {
  void queryClient.invalidateQueries({ queryKey: ['screens', organisationId] });
  void queryClient.invalidateQueries({ queryKey: ['screen-assignment', organisationId, screenId] });
  void queryClient.invalidateQueries({ queryKey: ['playlist-publish-state', organisationId] });
  void queryClient.invalidateQueries({ queryKey: ['playlist-items'] });
  void queryClient.invalidateQueries({ queryKey: ['playlist-version'] });
}
